





























































































































































































import Vue, { PropType } from "vue";
import { mapActions } from "vuex";
import { PostCloudContractsChangePlansEstimateResponse } from "@/containers/cloudContractsChangePlans/api";
import VcA from "@/components/A/A.vue";
import VcPrice from "@/components/Price/Price.vue";
import VcAboutCloudContractsChangePlans from "@/components/AboutCloudContractsChangePlans/AboutCloudContractsChangePlans.vue";
import VcAboutCloudContractsChangePlansPaymentInformation from "@/components/AboutCloudContractsChangePlans/CloudContractsChangePlansPaymentInformation.vue";

export interface CloudContractsChangePlansProps {
  action: string;
  lang: any;
  cloudTermsUrl: string;
  cloudAboutUrl: string;
  capacityList: string[];
  selectedPlanData: {
    capacityUnit: number;
    termUnit: string;
  };
  priceMap: any;
  planMap: any;
  termList: any;
  aboutHandlingUrl: string;
  aboutCalculationUrl: string;
  prevUrl: string;
  newPlanData: {
    capacityUnit: number;
    termUnit: string;
  };
  currencyCode: string;
  countryCode: string;
  contractNumber: string;
  aboutFreeTrialCalculationUrl: string;
  // PAY-4113 旧iPadEX版対応
  // 2026/1/19以降不要になるので適宜削除
  hasOldIpadExContract: boolean;
}

export interface CloudContractsChangePlansData {
  capacityUnit: number;
  termUnit: string;
  monthlyPrice: number;
  yearlyPrice: number;
  estimate: PostCloudContractsChangePlansEstimateResponse;
  hasFetchedEstimate: boolean;
}

export default Vue.extend({
  name: "vc-cloud-contracts-change-plans",
  components: {
    VcAboutCloudContractsChangePlansPaymentInformation,
    VcAboutCloudContractsChangePlans,
    VcPrice,
    VcA
  },

  data(): CloudContractsChangePlansData {
    return {
      capacityUnit: this.selectedPlanData.capacityUnit,
      termUnit: this.selectedPlanData.termUnit,
      monthlyPrice: Number(
        this.priceMap[this.planMap[this.newPlanData.capacityUnit]["month"]][
          this.currencyCode
        ]
      ),
      yearlyPrice: Number(
        this.priceMap[this.planMap[this.newPlanData.capacityUnit]["year"]][
          this.currencyCode
        ]
      ),
      estimate: {
        isUpgrade: false,
        oldPlanTranslatedName: "",
        newPlanTranslatedName: "",
        newPlanTerm: "",
        newPlanPrice: 0,
        nextInvoiceAt: 0,
        newPlanApplyAt: 0,
        priceDifference: 0
      },
      hasFetchedEstimate: false
    };
  },

  props: {
    action: {
      type: String as PropType<CloudContractsChangePlansProps["action"]>,
      default: ""
    },
    lang: {
      type: Object as PropType<CloudContractsChangePlansProps["lang"]>,
      default: () => {}
    },
    cloudTermsUrl: {
      type: String as PropType<CloudContractsChangePlansProps["cloudTermsUrl"]>,
      default: ""
    },
    cloudAboutUrl: {
      type: String as PropType<CloudContractsChangePlansProps["cloudAboutUrl"]>,
      default: ""
    },
    capacityList: {
      type: Object as PropType<CloudContractsChangePlansProps["capacityList"]>,
      default: () => {}
    },
    selectedPlanData: {
      type: Object as PropType<
        CloudContractsChangePlansProps["selectedPlanData"]
      >,
      default: {
        capacityUnit: 0,
        termUnit: ""
      }
    },
    priceMap: {
      type: Object as PropType<CloudContractsChangePlansProps["priceMap"]>,
      default: () => {}
    },
    planMap: {
      type: Object as PropType<CloudContractsChangePlansProps["planMap"]>,
      default: () => {}
    },
    termList: {
      type: Object as PropType<CloudContractsChangePlansProps["termList"]>,
      default: () => {}
    },
    aboutHandlingUrl: {
      type: String as PropType<
        CloudContractsChangePlansProps["aboutHandlingUrl"]
      >,
      default: ""
    },
    aboutCalculationUrl: {
      type: String as PropType<
        CloudContractsChangePlansProps["aboutCalculationUrl"]
      >,
      default: ""
    },
    prevUrl: {
      type: String as PropType<CloudContractsChangePlansProps["prevUrl"]>,
      default: ""
    },
    newPlanData: {
      type: Object as PropType<CloudContractsChangePlansProps["newPlanData"]>,
      default: {
        capacityUnit: 0,
        termUnit: ""
      }
    },
    currencyCode: {
      type: String as PropType<CloudContractsChangePlansProps["currencyCode"]>,
      default: ""
    },
    countryCode: {
      type: String as PropType<CloudContractsChangePlansProps["countryCode"]>,
      default: ""
    },
    contractNumber: {
      type: String as PropType<
        CloudContractsChangePlansProps["contractNumber"]
      >,
      default: ""
    },
    aboutFreeTrialCalculationUrl: {
      type: String as PropType<
        CloudContractsChangePlansProps["aboutFreeTrialCalculationUrl"]
      >,
      default: ""
    },
    hasOldIpadExContract: {
      type: Boolean as PropType<
        CloudContractsChangePlansProps["hasOldIpadExContract"]
      >,
      default: false
    }
  },

  mounted() {
    this.changePrice();
  },

  methods: {
    ...mapActions("cloudContractsChangePlans", [
      "postCloudContractsChangePlansEstimate"
    ]),
    submitPlan() {
      const formElement = this.$refs.changeForm as HTMLFormElement;
      const inputPlan = document.createElement("input");
      inputPlan.setAttribute("type", "hidden");
      inputPlan.setAttribute("name", "planCode");
      inputPlan.setAttribute(
        "value",
        this.planMap[this.capacityUnit][this.termUnit]
      );
      formElement.appendChild(inputPlan);
      formElement.submit();
    },
    async changePrice() {
      this.monthlyPrice = Number(
        this.priceMap[this.planMap[this.capacityUnit]["month"]][
          this.currencyCode
        ]
      );
      this.yearlyPrice = Number(
        this.priceMap[this.planMap[this.capacityUnit]["year"]][
          this.currencyCode
        ]
      );

      if (this.isSameAsOldPlan()) {
        this.hasFetchedEstimate = false;
        return;
      }

      this.estimate = await this.postCloudContractsChangePlansEstimate({
        planCode: this.planMap[this.capacityUnit][this.termUnit],
        contractNumber: this.contractNumber
      });

      if (this.isSameAsOldPlan()) {
        this.hasFetchedEstimate = false;
      } else {
        this.hasFetchedEstimate = true;
      }
    },
    isSelectedCapacityUnit(capacityUnit: number): boolean {
      return this.newPlanData.capacityUnit === capacityUnit;
    },
    isSelectedTermUnit(termUnit: string): boolean {
      return this.newPlanData.termUnit === termUnit;
    },
    isSameAsOldPlan() {
      return (
        this.isSelectedCapacityUnit(this.capacityUnit) &&
        this.isSelectedTermUnit(this.termUnit)
      );
    },
    isAppliedCapacity(index: string | number): boolean {
      return this.hasOldIpadExContract && index.toString() === "100";
    }
  }
});
